const SHIPMENT_MODES = ['Sea', 'Air', 'Land'] as const;

export const shipmentModeOptions = SHIPMENT_MODES.map((mode) => ({
  value: mode,
  text: mode,
}));

export const shipmentModeSelectOptions = [
  { value: '', label: 'Select..' },
  ...SHIPMENT_MODES.map((mode) => ({
    value: mode,
    label: mode,
  })),
];
